import { useState, useCallback } from "react";

export function useTurnstile() {
  const [turnstileToken, setTurnstileToken] = useState("");
  const [resetKey, setResetKey] = useState(0);

  const onVerify = useCallback((token) => {
    setTurnstileToken(token);
  }, []);

  const onExpire = useCallback(() => {
    setTurnstileToken("");
  }, []);

  const onError = useCallback(() => {
    setTurnstileToken("");
  }, []);

  const resetTurnstile = useCallback(() => {
    setTurnstileToken("");
    setResetKey((key) => key + 1);
  }, []);

  return {
    turnstileToken,
    resetKey,
    onVerify,
    onExpire,
    onError,
    resetTurnstile,
    isReady: Boolean(turnstileToken),
  };
}
